const examinationResults = {
  title: 'Examination Results',
  verification1: 'Verification 1',
  verification2: 'Verification 2',
  review: 'Review',
  validated: 'Validated',
  unreview: 'Unreview',
  preparation: 'Preparation',
  errorItem:
    'The examination item cannot be submitted because no examination item selected',
  examinationResultPatient: {
    title: 'Examination Result Patient',
    infoPatient: {
      mrNumber: 'MR No.',
      visitDate: 'Visit Date',
      name: 'Name',
      package: 'Package',
      client: 'Client',
      location: 'Location',
      dobgender: 'Gender / DOB'
    }
  },
  label: {
    generateItem: 'Generate Item',
    uploadAttachment: 'Upload Attachment',
    generateResume: 'Generate Resume',
    reItem: 'Re-Item',
    newResult: 'New Result',
    notCheck: 'Not Check',
    notPublish: 'Not Publish',
    rightTeeth: 'Right Teeth',
    leftTeeth: 'Left Teeth',
    rightEar: 'Right Ear',
    leftEar: 'Left Ear',
    airConduction: 'Air Conduction',
    boneConduction: 'Bone Conduction',
    rightResult: 'Right Result',
    leftResult: 'Left Result',
    addDescription: 'Add Description',
    uploadAttachment: 'Upload Attachment',
    examinationNote: 'Examination Note',
    generateCriticalCase: 'Generate Critical Case',
    publishNotPublish: 'Publish / Not Publish'
  },
  modalVerifyAll: {
    title: 'Confirm Verify All',
    message: 'Are you sure want to verify all examination items?'
  },
  modalReview: {
    title: 'Confirm Review',
    message: 'Are you sure want to submit review patient?'
  },
  modalSubmit: {
    title: 'Confirm Submit',
    message: 'Are you sure want to submit selected Examination Items?',
    messageAttachment: 'Are you sure want to submit selected Attacment?'
  },
  modalSubmitVerif: {
    title: 'Confirm Verification',
    message: 'Are you sure want to Verify selected Examination Items?',
    messageAttachment: 'Are you sure want to Verify selected Attachment?'
  },
  modalSubmitValidate: {
    title: 'Confirm Validation',
    message: 'Are you sure want to Validate selected Examination Items?',
    messageAttachment: 'Are you sure want to Validate selected Attachment?'
  },
  modalSubmitVerifResume: {
    title: 'Confirm Verification',
    message: 'Are you sure want to Verify Resume?'
  },
  modalSubmitReview: {
    title: 'Confirm Review',
    message: 'Are you sure want to submit review patient?'
  },
  modalSubmitTask: {
    title: 'Confirm Submit Task',
    message: 'Are you sure want to submit task?'
  },
  modalConfirmPatient: {
    title: 'Confirm Submit',
    message: 'Are you sure want to submit data patient?'
  },
  modalVerifPatient: {
    title: 'Confirm Verification',
    message: 'Are you sure want to Verify data patient?'
  },
  modalReviewPatient: {
    title: 'Confirm Review',
    message: 'Are you sure want to Review data patient?'
  },
  modalDeleteAttachment: {
    title: 'Confirm Delete',
    message: 'Are you sure want to delete {{fileName}}?'
  },
  modalAttach: {
    title: 'Confirm Attach',
    message: 'Are you sure want to attach {{fileName}}?'
  },
  modalDetach: {
    title: 'Confirm Detach',
    message: 'Are you sure want to detach {{fileName}}?'
  },
  modalUploadAttachment: {
    title: 'Upload Attachment',
    attachment: 'Attachment File',
    description: 'Description',
    message:
      'You can upload the allowed file types : .jpg, .jpeg, .png, .bmp, .pdf'
  },
  modalCancelSubmitPatient: {
    title: 'Confirm Cancel Submit',
    message: 'Are you sure want to cancel submit data patient?'
  },
  modalCancelVerif: {
    title: 'Confirm Unverify',
    message: 'Are you sure want to Unverify data ?'
  },
  modalCancelUnReview: {
    title: 'Confirm Unreview',
    message: 'Are you sure want to Unreview data ?'
  },
  modalCancelReviewPatient: {
    title: 'Confirm Unreview',
    message: 'Are you sure want to Unreview data patient?'
  },
  modalCancelValidationPatient: {
    title: 'Confirm Invalidate',
    message: 'Are you sure want to Invalidate data patient?'
  },
  modalConfirmationTask: {
    taskLabel: 'Task',
    type: 'Type',
    inputLabel: 'Description',
    title: 'Confirmation Task'
  },
  modalComment: {
    inputLabel: 'Comment',
    confirmation: 'Confirmation',
    revision: 'Revision',
    noRevision: 'No Revision'
  },
  modalRevisionTask: {
    taskLabel: 'Task',
    category: 'Type',
    inputLabel: 'Description',
    title: 'Revision Task'
  },
  modalCancelItem: {
    title: 'Confirm Cancel Item',
    message: 'Are you sure want to cancel submit?',
    messageAttachment: 'Are you sure want to cancel submit selected attachment?'
  },
  modalCancelVerif: {
    title: 'Confirm Unverify',
    message: 'Are you sure want to unverify?',
    messageAttachment: 'Are you sure want to unverify selected attachment?'
  },
  modalCancelVerifPatient: {
    title: 'Confirm Unverify',
    message: 'Are you sure want to unverify data patient?'
  },
  modalCancelReview: {
    title: 'Confirm Unreview',
    message: 'Are you sure want to unreview?'
  },
  modalNotPublish: {
    title: 'Confirm Not Publish',
    message: 'Are you sure want to set {{field}} result not publish?'
  },
  modalPublish: {
    title: 'Confirm Publish',
    message: 'Are you sure want to set {{field}} result publish?'
  },
  modalGenerateItem: {
    title: 'Confirm Generate Item',
    message: 'Are you sure want to Generate Examination Item?'
  },
  modalReItem: {
    title: 'Confirm Re-Item',
    message: 'Are you sure want to Re-Item {{field}} Examination?'
  },
  modalNotCheck: {
    title: 'Not Check',
    inputLabel: 'Note',
    notCheck: 'Not Check',
    cancel: 'Cancel Not Check'
  },
  modalGenerateCriticalCase: {
    title: 'Confirm Generate Critical Case',
    message: 'Are you sure want to generate Critical Case to selected patient?'
  },
  modalNotPublishV2: {
    title: 'Confirm Not Publish',
    message: 'Are you sure want to set {{field}} to not publish?'
  },
  modalPublishV2: {
    title: 'Confirm Publish',
    message: 'Are you sure want to set {{field}} to publish?'
  },
  modalPin: {
    title: 'Confirm Set Pin',
    message: 'Are you sure want to set pin selected comment?'
  },
  modalUnpin: {
    title: 'Confirm Set Unpin',
    message: 'Are you sure want to set unpin selected comment?'
  },
  sidebarHistory: {
    title: 'History Log',
    createdBy: 'Created By',
    createdAt: 'Created At',
    action: 'Action',
    changes: 'Changes',
    valueBefore: 'Value Before',
    valueAfter: 'Value After'
  },
  sidebarTaskActivity: {
    title: 'Detail Task Activity',
    createdAt: 'Created At',
    section: 'Section',
    description: 'Description',
    category: 'Category',
    type: 'Type',
    comment: 'Comment'
  },
  modalReOpen: {
    title: 'Confirm Re-Open',
    message: 'Are you sure want to Re-Open this task?'
  },
  modalDeleteTask: {
    title: 'Confirm Delete',
    message: 'Are you sure want to delete this task?'
  },
  modalPending: {
    title: 'Pending',
    inputLabel: 'Note',
    pending: 'Pending',
    cancel: 'Cancel Pending'
  },
  modalNewResult: {
    title: 'Select Item New Result',
    columnExaminationItem: 'Examination Item'
  },
  modalBulkUploadAttachment: {
    title: 'Upload Bulk Attachment',
    confirmDelete: {
      title: 'Confirm Delete Section Files',
      message: 'Are you sure want to delete section files {{field}}?'
    },
    confirmUpload: {
      title: 'Confirm Upload',
      message: 'Are you sure want to upload listed attachments?',
      message2: 'Are you sure want to upload listed documents?'
    },
    confirmStop: {
      title: 'Confirm Stop Process',
      message: 'Are you sure want to stop process?'
    },
    modalDetail: {
      title: 'Detail Upload Process',
      column: {
        filesName: 'Files Name',
        status: 'Status',
        remarks: 'Remarks',
        failed: 'Failed'
      }
    },
    modalInfo: {
      title: 'Field Upload Info',
      message1:
        '* You can upload the allowed file types : .jpg, .jpeg, .png, .bmp, .pdf',
      message1Update:'* You can upload the allowed file types : .jpg, .jpeg, .png, .bmp, .doc, .docx, .xls, .xlsx',
      message2:
        '* You can upload the allowed file size 5 MB for file type (.jpg, .jpeg, .png, .bmp) & 10 MB for file types (.pdf)',
      message2Update: '* You can upload the allowed size 5 MB for file type (.jpg, .jpeg, .png, .bmp) & 10 MB for file types (.pdf, .doc, .docx, .xls, .xlsx)'
    }
  },
  patientList: {
    column: {
      productReg: 'Product Reg. No',
      mrNo: 'MR No',
      patientName: 'Patient Name',
      patientCategory: 'Patient Category',
      reviewedBy: 'Reviewed By',
      reviewedAt: 'Reviewed At',
      validatedBy: 'Validated By',
      validatedAt: 'Validated At',
      review: 'Review',
      status: 'Status',
      submit: 'Submit',
      verif: 'Verify',
      validated: 'Validate',
      cancelVerif: 'Unverify',
      cancel: 'Cancel Submit',
      exclamation: 'Need Action',
      criticalCase: 'Critical Case',
      preparation: 'Preparation',
      verification1: 'Verification',
      verification2: 'Verification',
      verification: 'Verification',
      validation: 'Validation',
      resultNo: 'Patient Result No'
    },
    expander: {
      identityNumber: 'Identity Number',
      gender: 'Gender',
      dob: 'Date of Birth',
      mobilePhone: 'Mobile Phone',
      email: 'Email',
      employeeNumber: 'Employee Number',
      department: 'Department',
      projectName: 'Project Name',
      package: 'Package',
      note: 'Note',
      publishedResultNo: 'Published Result No.'
    },
    advanceSearch: {
      title: 'Advance Search Data Examination Result',
      patientCategory: 'Patient Category',
      selectPatientCategory: 'Select Patient Category',
      client: 'Client',
      selectClient: 'Select Client',
      team: 'Team ID',
      actualLocation: 'Actual Location',
      selectActualLocation: 'Select Actual Location',
      selectTeam: 'Select Branch Team ID',
      productCategory: 'Product Category',
      selectProductCategory: 'Select Product Category',
      project: 'Partner Project',
      partner: 'Partner',
      selectPartner: 'Select Partner',
      partnerBranch: 'Partner Branch',
      selectPartnerBranch: 'Select Partner Branch',
      selectProject: 'Select Partner Project',
      clientGroupSub: 'Client Group / Sub Contract',
      selectClientGroupSub: 'Select Client Group / Sub Contract',
      clientLocation: 'Client Location',
      selectClientLocation: 'Select Client Location',
      visitCategory: 'Visit Category',
      visitType: 'Visit Type',
      selectVisitType: 'Select Visit Type',
      patientClassification: 'Patient Classification',
      selectPatientClassification: 'Select Patient Classification',
      selectVisitCategory: 'Select Visit Category',
      branch: 'Branch',
      selectBranch: 'Select Branch',
      visitDate: 'Visit Date',
      gender: 'Gender',
      selectGender: 'Select Gender',
      status: 'Status',
      selectStatus: 'Select Status',
      statusCategory: 'Status Category',
      selectStatusCategory: 'Select Status Category',
      criticalCase: 'Critical Case',
      selectCriticalCase: 'Select Critical Case',
      statusFee: 'Status Fee',
      selectStatusFee: 'Select Status Fee',
      statusData: 'Status Data',
      selectStatusData: 'Select Status Data'
    }
  }
}
export default examinationResults
